module.exports = __webpack_public_path__ + "img/cover.e02be498.jpg";